module.exports = __webpack_public_path__ + "img/dailymotion-source.c288a76a.svg";